document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("signup-modal");
  if (!modal) return;

  const closeBtn = modal.querySelector(".bldg-modal-close");
  let hasShown = false;

  function showModal() {
    if (!hasShown) {
      modal.classList.add("show");
      hasShown = true;
    }
  }

  function hideModal() {
    modal.classList.remove("show");
  }

  function getScrollPercentage() {
    const article = document.querySelector(".article-text");
    if (!article) return 0;
    const rect = article.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return Math.max(0, Math.min(1, 1 - (rect.top + rect.height * 0.25) / windowHeight));
  }

  window.addEventListener("scroll", function () {
    const scrollPercentage = getScrollPercentage();
    if (scrollPercentage > 0.25) {
      showModal();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", hideModal);
  }

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      hideModal();
    }
  });
});